//This is the Admin Registration Setup Page.  It is used by admins to
//set up the type of league, event, or activity that users will register for.
//Whatever is added to this page will show up as an option for the users
//on the 'Register' page.
import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../../shared/context/auth-context'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import './../../admin/components/AdminRegistration.css'
import { NavLink, Link, useNavigate } from 'react-router-dom'
import Footer from '../../shared/components/UIElements/Footer'
import emailjs from 'emailjs-com'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import Button from '../../shared/components/UIElements/Button'
import HomeHomeNavigation from '../../shared/components/Navigation/HomeHomeNavigation'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ModalEmail from '../../shared/components/UIElements/ModalEmail'

const NonAdminRegisteredTeams = () => {
	const auth = useContext(AuthContext)
	const [isLoading, setIsLoading] = useState(false)
	const [rem, setRem] = useState('20rem')
	const [error, setError] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [year, setYear] = useState()
	const [org, setOrg] = useState()
	const [emailModal, setEmailModal] = useState()
	const [rosterModal, setRosterModal] = useState()
	const [filteredLoadedOrgs, setFilteredLoadedOrgs] = useState()
	const [filteredLoadedTeams, setFilteredLoadedTeams] = useState()
	const [emailAddresses, setEmailAddresses] = useState()
	//const [filteredByYear, setFilteredByYear] = useState()
	const [teamName, setTeamName] = useState()
	const [dateOfLastEdit, setDateOfLastEdit] = useState()
	const [loadedOrgs, setLoadedOrgs] = useState()
	const [orgDropdownCreated, setOrgDropdownCreated] = useState(false)
	const [orgArray, setOrgArray] = useState([])
	const [selectedTeamObj, setSelectedTeamObj] = useState(null)
	const [teamArray, setTeamArray] = useState([])
	const [selectedFilterOrg, setSelectedFilterOrg] = useState('')
	const [selectedFilterTeam, setSelectedFilterTeam] = useState('')
	const [isMobileFilters, setIsMobileFilters] = useState(
		typeof window !== 'undefined' ? window.innerWidth <= 440 : false,
	)
	//
	const [name1, setName1] = useState()
	const [number1, setNumber1] = useState()
	const [BY1, setBY1] = useState()
	const [isGoalie1, setIsGoalie1] = useState()
	const [isTaxi1, setIsTaxi1] = useState()
	//
	const [name2, setName2] = useState()
	const [number2, setNumber2] = useState()
	const [BY2, setBY2] = useState()
	const [isGoalie2, setIsGoalie2] = useState()
	const [isTaxi2, setIsTaxi2] = useState()
	//
	const [name3, setName3] = useState()
	const [number3, setNumber3] = useState()
	const [BY3, setBY3] = useState()
	const [isGoalie3, setIsGoalie3] = useState()
	const [isTaxi3, setIsTaxi3] = useState()
	//
	const [name4, setName4] = useState()
	const [number4, setNumber4] = useState()
	const [BY4, setBY4] = useState()
	const [isGoalie4, setIsGoalie4] = useState()
	const [isTaxi4, setIsTaxi4] = useState()
	//
	const [name5, setName5] = useState()
	const [number5, setNumber5] = useState()
	const [BY5, setBY5] = useState()
	const [isGoalie5, setIsGoalie5] = useState()
	const [isTaxi5, setIsTaxi5] = useState()
	//
	const [name6, setName6] = useState()
	const [number6, setNumber6] = useState()
	const [BY6, setBY6] = useState()
	const [isGoalie6, setIsGoalie6] = useState()
	const [isTaxi6, setIsTaxi6] = useState()
	//
	const [name7, setName7] = useState()
	const [number7, setNumber7] = useState()
	const [BY7, setBY7] = useState()
	const [isGoalie7, setIsGoalie7] = useState()
	const [isTaxi7, setIsTaxi7] = useState()
	//
	const [name8, setName8] = useState()
	const [number8, setNumber8] = useState()
	const [BY8, setBY8] = useState()
	const [isGoalie8, setIsGoalie8] = useState()
	const [isTaxi8, setIsTaxi8] = useState()
	//
	const [name9, setName9] = useState()
	const [number9, setNumber9] = useState()
	const [BY9, setBY9] = useState()
	const [isGoalie9, setIsGoalie9] = useState()
	const [isTaxi9, setIsTaxi9] = useState()
	//
	const [name10, setName10] = useState()
	const [number10, setNumber10] = useState()
	const [BY10, setBY10] = useState()
	const [isGoalie10, setIsGoalie10] = useState()
	const [isTaxi10, setIsTaxi10] = useState()
	//
	const [name11, setName11] = useState()
	const [number11, setNumber11] = useState()
	const [BY11, setBY11] = useState()
	const [isGoalie11, setIsGoalie11] = useState()
	const [isTaxi11, setIsTaxi11] = useState()
	//
	const [name12, setName12] = useState()
	const [number12, setNumber12] = useState()
	const [BY12, setBY12] = useState()
	const [isGoalie12, setIsGoalie12] = useState()
	const [isTaxi12, setIsTaxi12] = useState()
	//
	const [name13, setName13] = useState()
	const [number13, setNumber13] = useState()
	const [BY13, setBY13] = useState()
	const [isGoalie13, setIsGoalie13] = useState()
	const [isTaxi13, setIsTaxi13] = useState()
	//
	const [name14, setName14] = useState()
	const [number14, setNumber14] = useState()
	const [BY14, setBY14] = useState()
	const [isGoalie14, setIsGoalie14] = useState()
	const [isTaxi14, setIsTaxi14] = useState()
	//
	const [name15, setName15] = useState()
	const [number15, setNumber15] = useState()
	const [BY15, setBY15] = useState()
	const [isGoalie15, setIsGoalie15] = useState()
	const [isTaxi15, setIsTaxi15] = useState()
	//
	const [name16, setName16] = useState()
	const [number16, setNumber16] = useState()
	const [BY16, setBY16] = useState()
	const [isGoalie16, setIsGoalie16] = useState()
	const [isTaxi16, setIsTaxi16] = useState()
	//
	const [name17, setName17] = useState()
	const [number17, setNumber17] = useState()
	const [BY17, setBY17] = useState()
	const [isGoalie17, setIsGoalie17] = useState()
	const [isTaxi17, setIsTaxi17] = useState()
	//
	const [name18, setName18] = useState()
	const [number18, setNumber18] = useState()
	const [BY18, setBY18] = useState()
	const [isGoalie18, setIsGoalie18] = useState()
	const [isTaxi18, setIsTaxi18] = useState()
	//
	const [name19, setName19] = useState()
	const [number19, setNumber19] = useState()
	const [BY19, setBY19] = useState()
	const [isGoalie19, setIsGoalie19] = useState()
	const [isTaxi19, setIsTaxi19] = useState()
	//
	const [name20, setName20] = useState()
	const [number20, setNumber20] = useState()
	const [BY20, setBY20] = useState()
	const [isGoalie20, setIsGoalie20] = useState()
	const [isTaxi20, setIsTaxi20] = useState()
	//
	const [name21, setName21] = useState()
	const [number21, setNumber21] = useState()
	const [BY21, setBY21] = useState()
	const [isGoalie21, setIsGoalie21] = useState()
	const [isTaxi21, setIsTaxi21] = useState()
	//
	const [name22, setName22] = useState()
	const [number22, setNumber22] = useState()
	const [BY22, setBY22] = useState()
	const [isGoalie22, setIsGoalie22] = useState()
	const [isTaxi22, setIsTaxi22] = useState()
	//
	const [name23, setName23] = useState()
	const [number23, setNumber23] = useState()
	const [BY23, setBY23] = useState()
	const [isGoalie23, setIsGoalie23] = useState()
	const [isTaxi23, setIsTaxi23] = useState()
	//
	const [name24, setName24] = useState()
	const [number24, setNumber24] = useState()
	const [BY24, setBY24] = useState()
	const [isGoalie24, setIsGoalie24] = useState()
	const [isTaxi24, setIsTaxi24] = useState()
	//
	const [name25, setName25] = useState()
	const [number25, setNumber25] = useState()
	const [BY25, setBY25] = useState()
	const [isGoalie25, setIsGoalie25] = useState()
	const [isTaxi25, setIsTaxi25] = useState()
	//
	const [name26, setName26] = useState()
	const [number26, setNumber26] = useState()
	const [BY26, setBY26] = useState()
	const [isGoalie26, setIsGoalie26] = useState()
	const [isTaxi26, setIsTaxi26] = useState()
	//
	const [name27, setName27] = useState()
	const [number27, setNumber27] = useState()
	const [BY27, setBY27] = useState()
	const [isGoalie27, setIsGoalie27] = useState()
	const [isTaxi27, setIsTaxi27] = useState()
	//
	const [name28, setName28] = useState()
	const [number28, setNumber28] = useState()
	const [BY28, setBY28] = useState()
	const [isGoalie28, setIsGoalie28] = useState()
	const [isTaxi28, setIsTaxi28] = useState()
	//
	const [name29, setName29] = useState()
	const [number29, setNumber29] = useState()
	const [BY29, setBY29] = useState()
	const [isGoalie29, setIsGoalie29] = useState()
	const [isTaxi29, setIsTaxi29] = useState()
	//
	const [name30, setName30] = useState()
	const [number30, setNumber30] = useState()
	const [BY30, setBY30] = useState()
	const [isGoalie30, setIsGoalie30] = useState()
	const [isTaxi30, setIsTaxi30] = useState()
	//
	const [isActive1, setIsActive1] = useState()
	const [isActive2, setIsActive2] = useState()
	const [isActive3, setIsActive3] = useState()
	const [isActive4, setIsActive4] = useState()
	const [isActive5, setIsActive5] = useState()
	const [isActive6, setIsActive6] = useState()
	const [isActive7, setIsActive7] = useState()
	const [isActive8, setIsActive8] = useState()
	const [isActive9, setIsActive9] = useState()
	const [isActive10, setIsActive10] = useState()
	const [isActive11, setIsActive11] = useState()
	const [isActive12, setIsActive12] = useState()
	const [isActive13, setIsActive13] = useState()
	const [isActive14, setIsActive14] = useState()
	const [isActive15, setIsActive15] = useState()
	const [isActive16, setIsActive16] = useState()
	const [isActive17, setIsActive17] = useState()
	const [isActive18, setIsActive18] = useState()
	const [isActive19, setIsActive19] = useState()
	const [isActive20, setIsActive20] = useState()
	const [isActive21, setIsActive21] = useState()
	const [isActive22, setIsActive22] = useState()
	const [isActive23, setIsActive23] = useState()
	const [isActive24, setIsActive24] = useState()
	const [isActive25, setIsActive25] = useState()
	const [isActive26, setIsActive26] = useState()
	const [isActive27, setIsActive27] = useState()
	const [isActive28, setIsActive28] = useState()
	const [isActive29, setIsActive29] = useState()
	const [isActive30, setIsActive30] = useState()
	const [isCommitted1, setIsCommitted1] = useState()
	const [isCommitted2, setIsCommitted2] = useState()
	const [isCommitted3, setIsCommitted3] = useState()
	const [isCommitted4, setIsCommitted4] = useState()
	const [isCommitted5, setIsCommitted5] = useState()
	const [isCommitted6, setIsCommitted6] = useState()
	const [isCommitted7, setIsCommitted7] = useState()
	const [isCommitted8, setIsCommitted8] = useState()
	const [isCommitted9, setIsCommitted9] = useState()
	const [isCommitted10, setIsCommitted10] = useState()
	const [isCommitted11, setIsCommitted11] = useState()
	const [isCommitted12, setIsCommitted12] = useState()
	const [isCommitted13, setIsCommitted13] = useState()
	const [isCommitted14, setIsCommitted14] = useState()
	const [isCommitted15, setIsCommitted15] = useState()
	const [isCommitted16, setIsCommitted16] = useState()
	const [isCommitted17, setIsCommitted17] = useState()
	const [isCommitted18, setIsCommitted18] = useState()
	const [isCommitted19, setIsCommitted19] = useState()
	const [isCommitted20, setIsCommitted20] = useState()
	const [isCommitted21, setIsCommitted21] = useState()
	const [isCommitted22, setIsCommitted22] = useState()
	const [isCommitted23, setIsCommitted23] = useState()
	const [isCommitted24, setIsCommitted24] = useState()
	const [isCommitted25, setIsCommitted25] = useState()
	const [isCommitted26, setIsCommitted26] = useState()
	const [isCommitted27, setIsCommitted27] = useState()
	const [isCommitted28, setIsCommitted28] = useState()
	const [isCommitted29, setIsCommitted29] = useState()
	const [isCommitted30, setIsCommitted30] = useState()
	//
	//First, lets tap into the following route on the backend to get all
	//the CURRENT registered teams.  getAllRegisteredTeams
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL +
						`/registration/allRegisteredTeams`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.allRegisteredTeams)
				setEmailAddresses(responseData.allEmailAddresses)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//console.log('loadedTeams: ' + JSON.stringify(loadedTeams))
	//
	//
	let emailAddressesArray, uniqueEmailAddresses
	emailAddressesArray = []
	if (emailAddresses) {
		emailAddresses.forEach((emailAddress) => {
			emailAddressesArray.push(emailAddress)
		})
	}
	//
	//
	if (emailAddressesArray.length > 0) {
		uniqueEmailAddresses = emailAddressesArray.filter(
			(value, index) => emailAddressesArray.indexOf(value) === index,
		)
	}
	//
	let totalActivePlayers = 0
	if (loadedTeams) {
		if (isActive1) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive2) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive3) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive4) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive5) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive6) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive7) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive8) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive9) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive10) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive11) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive12) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive13) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive14) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive15) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive16) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive17) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive18) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive19) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive20) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive21) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive22) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive23) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive24) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive25) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive26) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive27) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive28) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive29) {
			totalActivePlayers = totalActivePlayers + 1
		}
		if (isActive30) {
			totalActivePlayers = totalActivePlayers + 1
		}
	}
	//
	//
	useEffect(() => {
		const handleResize = () => {
			setIsMobileFilters(window.innerWidth <= 440)
		}

		handleResize()

		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])
	//
	//
	//
	//
	//Next, lets call the backend to get all the organizations for our dropdown
	//     allOrgs
	useEffect(() => {
		console.log('useEffect')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allOrgs',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setLoadedOrgs(responseData.allOrgs)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//This creates an array from the loadedOrgs.  It will be our 'Organization' dropdown:
	if (loadedOrgs && !isLoading && !orgDropdownCreated) {
		const innerOrgArray = []
		loadedOrgs.forEach((org) => {
			const orgDisplay = org.orgName
			innerOrgArray.push(orgDisplay)
		})
		//NEW  This was added for leagues that have divisions
		let uniqueArray = []
		const duplicateFilter = innerOrgArray.filter((element) => {
			if (!uniqueArray.includes(element)) {
				uniqueArray.push(element)

				return true
			}
			return false
		})
		//end NEW
		setOrgArray(duplicateFilter)
		setOrgDropdownCreated(true)
	}
	//
	//
	//
	// Create unique Team dropdown options from the registered teams
	useEffect(() => {
		if (!loadedTeams) return

		const uniqueTeams = [
			...new Set(loadedTeams.map((team) => team.team).filter((team) => team)),
		].sort()

		setTeamArray(uniqueTeams)
	}, [loadedTeams])
	//
	//
	//
	//
	//
	let navigate = useNavigate()
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	let teamsFilteredByOrg
	teamsFilteredByOrg = []
	//
	const handleFilterByOrg = (e) => {
		const selectedOrg = e.target.value

		setSelectedFilterOrg(selectedOrg)

		// Clear Team filter because these filters do NOT work together
		setSelectedFilterTeam('')

		if (!selectedOrg) {
			setFilteredLoadedTeams(null)
			return
		}

		const teamsFilteredByOrg = loadedTeams.filter(
			(team) => team.organization === selectedOrg,
		)

		setFilteredLoadedTeams(teamsFilteredByOrg)
	}
	//
	//
	const handleFilterByTeam = (e) => {
		const selectedTeam = e.target.value

		setSelectedFilterTeam(selectedTeam)

		// Clear Organization filter because these filters do NOT work together
		setSelectedFilterOrg('')

		if (!selectedTeam) {
			setFilteredLoadedTeams(null)
			return
		}

		const teamsFilteredByTeam = loadedTeams.filter(
			(team) => team.team === selectedTeam,
		)

		setFilteredLoadedTeams(teamsFilteredByTeam)
	}
	//
	//
	const showEmailModal = (e) => {
		const value = e.target.id
		setEmailModal(true)
	}
	//
	//
	const cancelEmailHandler = () => {
		setEmailModal(false)
	}
	//
	//
	//
	function sendEmail(e) {
		e.preventDefault()

		emailjs
			.sendForm(
				'service_qeuvtpo',
				'template_htf42za',
				document.getElementById('emailForm'),
				'GFXJpgnQXBXpF8Y3w',
			)
			.then((res) => {
				console.log(res)
				alert('Your email is on its way!')
				setEmailModal(false)
			})
			.catch((err) => console.log(err))
	}
	//
	//
	//
	//
	const showRosterModal = (e, key) => {
		const value = e.target.id
		console.log('roster for: ' + key)

		const teamObj = filteredLoadedTeams
			? filteredLoadedTeams[key]
			: loadedTeams[key]
		setSelectedTeamObj(teamObj)

		if (filteredLoadedTeams) {
			setTeamName(filteredLoadedTeams[key].team)
			setOrg(filteredLoadedTeams[key].organization)
			setDateOfLastEdit(filteredLoadedTeams[key].date)
			//
			setName1(filteredLoadedTeams[key].name1)
			setNumber1(filteredLoadedTeams[key].number1)
			setBY1(filteredLoadedTeams[key].BY1)
			setIsGoalie1(filteredLoadedTeams[key].playerIsGoalie1)
			setIsTaxi1(filteredLoadedTeams[key].playerIsTaxi1)
			//
			setName2(filteredLoadedTeams[key].name2)
			setNumber2(filteredLoadedTeams[key].number2)
			setBY2(filteredLoadedTeams[key].BY2)
			setIsGoalie2(filteredLoadedTeams[key].playerIsGoalie2)
			setIsTaxi2(filteredLoadedTeams[key].playerIsTaxi2)
			//
			setName3(filteredLoadedTeams[key].name3)
			setNumber3(filteredLoadedTeams[key].number3)
			setBY3(filteredLoadedTeams[key].BY3)
			setIsGoalie3(filteredLoadedTeams[key].playerIsGoalie3)
			setIsTaxi3(filteredLoadedTeams[key].playerIsTaxi3)
			//
			setName4(filteredLoadedTeams[key].name4)
			setNumber4(filteredLoadedTeams[key].number4)
			setBY4(filteredLoadedTeams[key].BY4)
			setIsGoalie4(filteredLoadedTeams[key].playerIsGoalie4)
			setIsTaxi4(filteredLoadedTeams[key].playerIsTaxi4)
			//
			setName5(filteredLoadedTeams[key].name5)
			setNumber5(filteredLoadedTeams[key].number5)
			setBY5(filteredLoadedTeams[key].BY5)
			setIsGoalie5(filteredLoadedTeams[key].playerIsGoalie5)
			setIsTaxi5(filteredLoadedTeams[key].playerIsTaxi5)
			//
			setName6(filteredLoadedTeams[key].name6)
			setNumber6(filteredLoadedTeams[key].number6)
			setBY6(filteredLoadedTeams[key].BY6)
			setIsGoalie6(filteredLoadedTeams[key].playerIsGoalie6)
			setIsTaxi6(filteredLoadedTeams[key].playerIsTaxi6)
			//
			setName7(filteredLoadedTeams[key].name7)
			setNumber7(filteredLoadedTeams[key].number7)
			setBY7(filteredLoadedTeams[key].BY7)
			setIsGoalie7(filteredLoadedTeams[key].playerIsGoalie7)
			setIsTaxi7(filteredLoadedTeams[key].playerIsTaxi7)
			//
			setName8(filteredLoadedTeams[key].name8)
			setNumber8(filteredLoadedTeams[key].number8)
			setBY8(filteredLoadedTeams[key].BY8)
			setIsGoalie8(filteredLoadedTeams[key].playerIsGoalie8)
			setIsTaxi8(filteredLoadedTeams[key].playerIsTaxi8)
			//
			setName9(filteredLoadedTeams[key].name9)
			setNumber9(filteredLoadedTeams[key].number9)
			setBY9(filteredLoadedTeams[key].BY9)
			setIsGoalie9(filteredLoadedTeams[key].playerIsGoalie9)
			setIsTaxi9(filteredLoadedTeams[key].playerIsTaxi9)
			//
			setName10(filteredLoadedTeams[key].name10)
			setNumber10(filteredLoadedTeams[key].number10)
			setBY10(filteredLoadedTeams[key].BY10)
			setIsGoalie10(filteredLoadedTeams[key].playerIsGoalie10)
			setIsTaxi10(filteredLoadedTeams[key].playerIsTaxi10)
			//
			setName11(filteredLoadedTeams[key].name11)
			setNumber11(filteredLoadedTeams[key].number11)
			setBY11(filteredLoadedTeams[key].BY11)
			setIsGoalie11(filteredLoadedTeams[key].playerIsGoalie11)
			setIsTaxi11(filteredLoadedTeams[key].playerIsTaxi11)
			//
			setName12(filteredLoadedTeams[key].name12)
			setNumber12(filteredLoadedTeams[key].number12)
			setBY12(filteredLoadedTeams[key].BY12)
			setIsGoalie12(filteredLoadedTeams[key].playerIsGoalie12)
			setIsTaxi12(filteredLoadedTeams[key].playerIsTaxi12)
			//
			setName13(filteredLoadedTeams[key].name13)
			setNumber13(filteredLoadedTeams[key].number13)
			setBY13(filteredLoadedTeams[key].BY13)
			setIsGoalie13(filteredLoadedTeams[key].playerIsGoalie13)
			setIsTaxi13(filteredLoadedTeams[key].playerIsTaxi13)
			//
			setName14(filteredLoadedTeams[key].name14)
			setNumber14(filteredLoadedTeams[key].number14)
			setBY14(filteredLoadedTeams[key].BY14)
			setIsGoalie14(filteredLoadedTeams[key].playerIsGoalie14)
			setIsTaxi14(filteredLoadedTeams[key].playerIsTaxi14)
			//
			setName15(filteredLoadedTeams[key].name15)
			setNumber15(filteredLoadedTeams[key].number15)
			setBY15(filteredLoadedTeams[key].BY15)
			setIsGoalie15(filteredLoadedTeams[key].playerIsGoalie15)
			setIsTaxi15(filteredLoadedTeams[key].playerIsTaxi15)
			//
			setName16(filteredLoadedTeams[key].name16)
			setNumber16(filteredLoadedTeams[key].number16)
			setBY16(filteredLoadedTeams[key].BY16)
			setIsGoalie16(filteredLoadedTeams[key].playerIsGoalie16)
			setIsTaxi16(filteredLoadedTeams[key].playerIsTaxi16)
			//
			setName17(filteredLoadedTeams[key].name17)
			setNumber17(filteredLoadedTeams[key].number17)
			setBY17(filteredLoadedTeams[key].BY17)
			setIsGoalie17(filteredLoadedTeams[key].playerIsGoalie17)
			setIsTaxi17(filteredLoadedTeams[key].playerIsTaxi17)
			//
			setName18(filteredLoadedTeams[key].name18)
			setNumber18(filteredLoadedTeams[key].number18)
			setBY18(filteredLoadedTeams[key].BY18)
			setIsGoalie18(filteredLoadedTeams[key].playerIsGoalie18)
			setIsTaxi18(filteredLoadedTeams[key].playerIsTaxi18)
			//
			setName19(filteredLoadedTeams[key].name19)
			setNumber19(filteredLoadedTeams[key].number19)
			setBY19(filteredLoadedTeams[key].BY19)
			setIsGoalie19(filteredLoadedTeams[key].playerIsGoalie19)
			setIsTaxi19(filteredLoadedTeams[key].playerIsTaxi19)
			//
			setName20(filteredLoadedTeams[key].name20)
			setNumber20(filteredLoadedTeams[key].number20)
			setBY20(filteredLoadedTeams[key].BY20)
			setIsGoalie20(filteredLoadedTeams[key].playerIsGoalie20)
			setIsTaxi20(filteredLoadedTeams[key].playerIsTaxi20)
			//
			setName21(filteredLoadedTeams[key].name21)
			setNumber21(filteredLoadedTeams[key].number21)
			setBY21(filteredLoadedTeams[key].BY21)
			setIsGoalie21(filteredLoadedTeams[key].playerIsGoalie21)
			setIsTaxi21(filteredLoadedTeams[key].playerIsTaxi21)
			//
			setName22(filteredLoadedTeams[key].name22)
			setNumber22(filteredLoadedTeams[key].number22)
			setBY22(filteredLoadedTeams[key].BY22)
			setIsGoalie22(filteredLoadedTeams[key].playerIsGoalie22)
			setIsTaxi22(filteredLoadedTeams[key].playerIsTaxi22)
			//
			setName23(filteredLoadedTeams[key].name23)
			setNumber23(filteredLoadedTeams[key].number23)
			setBY23(filteredLoadedTeams[key].BY23)
			setIsGoalie23(filteredLoadedTeams[key].playerIsGoalie23)
			setIsTaxi23(filteredLoadedTeams[key].playerIsTaxi23)
			//
			setName24(filteredLoadedTeams[key].name24)
			setNumber24(filteredLoadedTeams[key].number24)
			setBY24(filteredLoadedTeams[key].BY24)
			setIsGoalie24(filteredLoadedTeams[key].playerIsGoalie24)
			setIsTaxi24(filteredLoadedTeams[key].playerIsTaxi24)
			//
			setName25(filteredLoadedTeams[key].name25)
			setNumber25(filteredLoadedTeams[key].number25)
			setBY25(filteredLoadedTeams[key].BY25)
			setIsGoalie25(filteredLoadedTeams[key].playerIsGoalie25)
			setIsTaxi25(filteredLoadedTeams[key].playerIsTaxi25)
			//
			setName26(filteredLoadedTeams[key].name26)
			setNumber26(filteredLoadedTeams[key].number26)
			setBY26(filteredLoadedTeams[key].BY26)
			setIsGoalie26(filteredLoadedTeams[key].playerIsGoalie26)
			setIsTaxi26(filteredLoadedTeams[key].playerIsTaxi26)
			//
			setName27(filteredLoadedTeams[key].name27)
			setNumber27(filteredLoadedTeams[key].number27)
			setBY27(filteredLoadedTeams[key].BY27)
			setIsGoalie27(filteredLoadedTeams[key].playerIsGoalie27)
			setIsTaxi27(filteredLoadedTeams[key].playerIsTaxi27)
			//
			setName28(filteredLoadedTeams[key].name28)
			setNumber28(filteredLoadedTeams[key].number28)
			setBY28(filteredLoadedTeams[key].BY28)
			setIsGoalie28(filteredLoadedTeams[key].playerIsGoalie28)
			setIsTaxi28(filteredLoadedTeams[key].playerIsTaxi28)
			//
			setName29(filteredLoadedTeams[key].name29)
			setNumber29(filteredLoadedTeams[key].number29)
			setBY29(filteredLoadedTeams[key].BY29)
			setIsGoalie29(filteredLoadedTeams[key].playerIsGoalie29)
			setIsTaxi29(filteredLoadedTeams[key].playerIsTaxi29)
			//
			setName30(filteredLoadedTeams[key].name30)
			setNumber30(filteredLoadedTeams[key].number30)
			setBY30(filteredLoadedTeams[key].BY30)
			setIsGoalie30(filteredLoadedTeams[key].playerIsGoalie30)
			setIsTaxi30(filteredLoadedTeams[key].playerIsTaxi30)
			//
			setIsActive1(filteredLoadedTeams[key].playerIsActive1)
			setIsActive2(filteredLoadedTeams[key].playerIsActive2)
			setIsActive3(filteredLoadedTeams[key].playerIsActive3)
			setIsActive4(filteredLoadedTeams[key].playerIsActive4)
			setIsActive5(filteredLoadedTeams[key].playerIsActive5)
			setIsActive6(filteredLoadedTeams[key].playerIsActive6)
			setIsActive7(filteredLoadedTeams[key].playerIsActive7)
			setIsActive8(filteredLoadedTeams[key].playerIsActive8)
			setIsActive9(filteredLoadedTeams[key].playerIsActive9)
			setIsActive10(filteredLoadedTeams[key].playerIsActive10)
			setIsActive11(filteredLoadedTeams[key].playerIsActive11)
			setIsActive12(filteredLoadedTeams[key].playerIsActive12)
			setIsActive13(filteredLoadedTeams[key].playerIsActive13)
			setIsActive14(filteredLoadedTeams[key].playerIsActive14)
			setIsActive15(filteredLoadedTeams[key].playerIsActive15)
			setIsActive16(filteredLoadedTeams[key].playerIsActive16)
			setIsActive17(filteredLoadedTeams[key].playerIsActive17)
			setIsActive18(filteredLoadedTeams[key].playerIsActive18)
			setIsActive19(filteredLoadedTeams[key].playerIsActive19)
			setIsActive20(filteredLoadedTeams[key].playerIsActive20)
			setIsActive21(filteredLoadedTeams[key].playerIsActive21)
			setIsActive22(filteredLoadedTeams[key].playerIsActive22)
			setIsActive23(filteredLoadedTeams[key].playerIsActive23)
			setIsActive24(filteredLoadedTeams[key].playerIsActive24)
			setIsActive25(filteredLoadedTeams[key].playerIsActive25)
			setIsActive26(filteredLoadedTeams[key].playerIsActive26)
			setIsActive27(filteredLoadedTeams[key].playerIsActive27)
			setIsActive28(filteredLoadedTeams[key].playerIsActive28)
			setIsActive29(filteredLoadedTeams[key].playerIsActive29)
			setIsActive30(filteredLoadedTeams[key].playerIsActive30)
			//
			setIsCommitted1(filteredLoadedTeams[key].playerIsCommitted1)
			setIsCommitted2(filteredLoadedTeams[key].playerIsCommitted2)
			setIsCommitted3(filteredLoadedTeams[key].playerIsCommitted3)
			setIsCommitted4(filteredLoadedTeams[key].playerIsCommitted4)
			setIsCommitted5(filteredLoadedTeams[key].playerIsCommitted5)
			setIsCommitted6(filteredLoadedTeams[key].playerIsCommitted6)
			setIsCommitted7(filteredLoadedTeams[key].playerIsCommitted7)
			setIsCommitted8(filteredLoadedTeams[key].playerIsCommitted8)
			setIsCommitted9(filteredLoadedTeams[key].playerIsCommitted9)
			setIsCommitted10(filteredLoadedTeams[key].playerIsCommitted10)
			setIsCommitted11(filteredLoadedTeams[key].playerIsCommitted11)
			setIsCommitted12(filteredLoadedTeams[key].playerIsCommitted12)
			setIsCommitted13(filteredLoadedTeams[key].playerIsCommitted13)
			setIsCommitted14(filteredLoadedTeams[key].playerIsCommitted14)
			setIsCommitted15(filteredLoadedTeams[key].playerIsCommitted15)
			setIsCommitted16(filteredLoadedTeams[key].playerIsCommitted16)
			setIsCommitted17(filteredLoadedTeams[key].playerIsCommitted17)
			setIsCommitted18(filteredLoadedTeams[key].playerIsCommitted18)
			setIsCommitted19(filteredLoadedTeams[key].playerIsCommitted19)
			setIsCommitted20(filteredLoadedTeams[key].playerIsCommitted20)
			setIsCommitted21(filteredLoadedTeams[key].playerIsCommitted21)
			setIsCommitted22(filteredLoadedTeams[key].playerIsCommitted22)
			setIsCommitted23(filteredLoadedTeams[key].playerIsCommitted23)
			setIsCommitted24(filteredLoadedTeams[key].playerIsCommitted24)
			setIsCommitted25(filteredLoadedTeams[key].playerIsCommitted25)
			setIsCommitted26(filteredLoadedTeams[key].playerIsCommitted26)
			setIsCommitted27(filteredLoadedTeams[key].playerIsCommitted27)
			setIsCommitted28(filteredLoadedTeams[key].playerIsCommitted28)
			setIsCommitted29(filteredLoadedTeams[key].playerIsCommitted29)
			setIsCommitted30(filteredLoadedTeams[key].playerIsCommitted30)
		} else {
			setTeamName(loadedTeams[key].team)
			setOrg(loadedTeams[key].organization)
			setDateOfLastEdit(loadedTeams[key].date)
			//
			setName1(loadedTeams[key].name1)
			setNumber1(loadedTeams[key].number1)
			setBY1(loadedTeams[key].BY1)
			setIsGoalie1(loadedTeams[key].playerIsGoalie1)
			setIsTaxi1(loadedTeams[key].playerIsTaxi1)
			//
			setName2(loadedTeams[key].name2)
			setNumber2(loadedTeams[key].number2)
			setBY2(loadedTeams[key].BY2)
			setIsGoalie2(loadedTeams[key].playerIsGoalie2)
			setIsTaxi2(loadedTeams[key].playerIsTaxi2)
			//
			setName3(loadedTeams[key].name3)
			setNumber3(loadedTeams[key].number3)
			setBY3(loadedTeams[key].BY3)
			setIsGoalie3(loadedTeams[key].playerIsGoalie3)
			setIsTaxi3(loadedTeams[key].playerIsTaxi3)
			//
			setName4(loadedTeams[key].name4)
			setNumber4(loadedTeams[key].number4)
			setBY4(loadedTeams[key].BY4)
			setIsGoalie4(loadedTeams[key].playerIsGoalie4)
			setIsTaxi4(loadedTeams[key].playerIsTaxi4)
			//
			setName5(loadedTeams[key].name5)
			setNumber5(loadedTeams[key].number5)
			setBY5(loadedTeams[key].BY5)
			setIsGoalie5(loadedTeams[key].playerIsGoalie5)
			setIsTaxi5(loadedTeams[key].playerIsTaxi5)
			//
			setName6(loadedTeams[key].name6)
			setNumber6(loadedTeams[key].number6)
			setBY6(loadedTeams[key].BY6)
			setIsGoalie6(loadedTeams[key].playerIsGoalie6)
			setIsTaxi6(loadedTeams[key].playerIsTaxi6)
			//
			setName7(loadedTeams[key].name7)
			setNumber7(loadedTeams[key].number7)
			setBY7(loadedTeams[key].BY7)
			setIsGoalie7(loadedTeams[key].playerIsGoalie7)
			setIsTaxi7(loadedTeams[key].playerIsTaxi7)
			//
			setName8(loadedTeams[key].name8)
			setNumber8(loadedTeams[key].number8)
			setBY8(loadedTeams[key].BY8)
			setIsGoalie8(loadedTeams[key].playerIsGoalie8)
			setIsTaxi8(loadedTeams[key].playerIsTaxi8)
			//
			setName9(loadedTeams[key].name9)
			setNumber9(loadedTeams[key].number9)
			setBY9(loadedTeams[key].BY9)
			setIsGoalie9(loadedTeams[key].playerIsGoalie9)
			setIsTaxi9(loadedTeams[key].playerIsTaxi9)
			//
			setName10(loadedTeams[key].name10)
			setNumber10(loadedTeams[key].number10)
			setBY10(loadedTeams[key].BY10)
			setIsGoalie10(loadedTeams[key].playerIsGoalie10)
			setIsTaxi10(loadedTeams[key].playerIsTaxi10)
			//
			setName11(loadedTeams[key].name11)
			setNumber11(loadedTeams[key].number11)
			setBY11(loadedTeams[key].BY11)
			setIsGoalie11(loadedTeams[key].playerIsGoalie11)
			setIsTaxi11(loadedTeams[key].playerIsTaxi11)
			//
			setName12(loadedTeams[key].name12)
			setNumber12(loadedTeams[key].number12)
			setBY12(loadedTeams[key].BY12)
			setIsGoalie12(loadedTeams[key].playerIsGoalie12)
			setIsTaxi12(loadedTeams[key].playerIsTaxi12)
			//
			setName13(loadedTeams[key].name13)
			setNumber13(loadedTeams[key].number13)
			setBY13(loadedTeams[key].BY13)
			setIsGoalie13(loadedTeams[key].playerIsGoalie13)
			setIsTaxi13(loadedTeams[key].playerIsTaxi13)
			//
			setName14(loadedTeams[key].name14)
			setNumber14(loadedTeams[key].number14)
			setBY14(loadedTeams[key].BY14)
			setIsGoalie14(loadedTeams[key].playerIsGoalie14)
			setIsTaxi14(loadedTeams[key].playerIsTaxi14)
			//
			setName15(loadedTeams[key].name15)
			setNumber15(loadedTeams[key].number15)
			setBY15(loadedTeams[key].BY15)
			setIsGoalie15(loadedTeams[key].playerIsGoalie15)
			setIsTaxi15(loadedTeams[key].playerIsTaxi15)
			//
			setName16(loadedTeams[key].name16)
			setNumber16(loadedTeams[key].number16)
			setBY16(loadedTeams[key].BY16)
			setIsGoalie16(loadedTeams[key].playerIsGoalie16)
			setIsTaxi16(loadedTeams[key].playerIsTaxi16)
			//
			setName17(loadedTeams[key].name17)
			setNumber17(loadedTeams[key].number17)
			setBY17(loadedTeams[key].BY17)
			setIsGoalie17(loadedTeams[key].playerIsGoalie17)
			setIsTaxi17(loadedTeams[key].playerIsTaxi17)
			//
			setName18(loadedTeams[key].name18)
			setNumber18(loadedTeams[key].number18)
			setBY18(loadedTeams[key].BY18)
			setIsGoalie18(loadedTeams[key].playerIsGoalie18)
			setIsTaxi18(loadedTeams[key].playerIsTaxi18)
			//
			setName19(loadedTeams[key].name19)
			setNumber19(loadedTeams[key].number19)
			setBY19(loadedTeams[key].BY19)
			setIsGoalie19(loadedTeams[key].playerIsGoalie19)
			setIsTaxi19(loadedTeams[key].playerIsTaxi19)
			//
			setName20(loadedTeams[key].name20)
			setNumber20(loadedTeams[key].number20)
			setBY20(loadedTeams[key].BY20)
			setIsGoalie20(loadedTeams[key].playerIsGoalie20)
			setIsTaxi20(loadedTeams[key].playerIsTaxi20)
			//
			setName21(loadedTeams[key].name21)
			setNumber21(loadedTeams[key].number21)
			setBY21(loadedTeams[key].BY21)
			setIsGoalie21(loadedTeams[key].playerIsGoalie21)
			setIsTaxi21(loadedTeams[key].playerIsTaxi21)
			//
			setName22(loadedTeams[key].name22)
			setNumber22(loadedTeams[key].number22)
			setBY22(loadedTeams[key].BY22)
			setIsGoalie22(loadedTeams[key].playerIsGoalie22)
			setIsTaxi22(loadedTeams[key].playerIsTaxi22)
			//
			setName23(loadedTeams[key].name23)
			setNumber23(loadedTeams[key].number23)
			setBY23(loadedTeams[key].BY23)
			setIsGoalie23(loadedTeams[key].playerIsGoalie23)
			setIsTaxi23(loadedTeams[key].playerIsTaxi23)
			//
			setName24(loadedTeams[key].name24)
			setNumber24(loadedTeams[key].number24)
			setBY24(loadedTeams[key].BY24)
			setIsGoalie24(loadedTeams[key].playerIsGoalie24)
			setIsTaxi24(loadedTeams[key].playerIsTaxi24)
			//
			setName25(loadedTeams[key].name25)
			setNumber25(loadedTeams[key].number25)
			setBY25(loadedTeams[key].BY25)
			setIsGoalie25(loadedTeams[key].playerIsGoalie25)
			setIsTaxi25(loadedTeams[key].playerIsTaxi25)
			//
			setName26(loadedTeams[key].name26)
			setNumber26(loadedTeams[key].number26)
			setBY26(loadedTeams[key].BY26)
			setIsGoalie26(loadedTeams[key].playerIsGoalie26)
			setIsTaxi26(loadedTeams[key].playerIsTaxi26)
			//
			setName27(loadedTeams[key].name27)
			setNumber27(loadedTeams[key].number27)
			setBY27(loadedTeams[key].BY27)
			setIsGoalie27(loadedTeams[key].playerIsGoalie27)
			setIsTaxi27(loadedTeams[key].playerIsTaxi27)
			//
			setName28(loadedTeams[key].name28)
			setNumber28(loadedTeams[key].number28)
			setBY28(loadedTeams[key].BY28)
			setIsGoalie28(loadedTeams[key].playerIsGoalie28)
			setIsTaxi28(loadedTeams[key].playerIsTaxi28)
			//
			setName29(loadedTeams[key].name29)
			setNumber29(loadedTeams[key].number29)
			setBY29(loadedTeams[key].BY29)
			setIsGoalie29(loadedTeams[key].playerIsGoalie29)
			setIsTaxi29(loadedTeams[key].playerIsTaxi29)
			//
			setName30(loadedTeams[key].name30)
			setNumber30(loadedTeams[key].number30)
			setBY30(loadedTeams[key].BY30)
			setIsGoalie30(loadedTeams[key].playerIsGoalie30)
			setIsTaxi30(loadedTeams[key].playerIsTaxi30)
			//
			setIsActive1(loadedTeams[key].playerIsActive1)
			setIsActive2(loadedTeams[key].playerIsActive2)
			setIsActive3(loadedTeams[key].playerIsActive3)
			setIsActive4(loadedTeams[key].playerIsActive4)
			setIsActive5(loadedTeams[key].playerIsActive5)
			setIsActive6(loadedTeams[key].playerIsActive6)
			setIsActive7(loadedTeams[key].playerIsActive7)
			setIsActive8(loadedTeams[key].playerIsActive8)
			setIsActive9(loadedTeams[key].playerIsActive9)
			setIsActive10(loadedTeams[key].playerIsActive10)
			setIsActive11(loadedTeams[key].playerIsActive11)
			setIsActive12(loadedTeams[key].playerIsActive12)
			setIsActive13(loadedTeams[key].playerIsActive13)
			setIsActive14(loadedTeams[key].playerIsActive14)
			setIsActive15(loadedTeams[key].playerIsActive15)
			setIsActive16(loadedTeams[key].playerIsActive16)
			setIsActive17(loadedTeams[key].playerIsActive17)
			setIsActive18(loadedTeams[key].playerIsActive18)
			setIsActive19(loadedTeams[key].playerIsActive19)
			setIsActive20(loadedTeams[key].playerIsActive20)
			setIsActive21(loadedTeams[key].playerIsActive21)
			setIsActive22(loadedTeams[key].playerIsActive22)
			setIsActive23(loadedTeams[key].playerIsActive23)
			setIsActive24(loadedTeams[key].playerIsActive24)
			setIsActive25(loadedTeams[key].playerIsActive25)
			setIsActive26(loadedTeams[key].playerIsActive26)
			setIsActive27(loadedTeams[key].playerIsActive27)
			setIsActive28(loadedTeams[key].playerIsActive28)
			setIsActive29(loadedTeams[key].playerIsActive29)
			setIsActive30(loadedTeams[key].playerIsActive30)
			//
			setIsCommitted1(loadedTeams[key].playerIsCommitted1)
			setIsCommitted2(loadedTeams[key].playerIsCommitted2)
			setIsCommitted3(loadedTeams[key].playerIsCommitted3)
			setIsCommitted4(loadedTeams[key].playerIsCommitted4)
			setIsCommitted5(loadedTeams[key].playerIsCommitted5)
			setIsCommitted6(loadedTeams[key].playerIsCommitted6)
			setIsCommitted7(loadedTeams[key].playerIsCommitted7)
			setIsCommitted8(loadedTeams[key].playerIsCommitted8)
			setIsCommitted9(loadedTeams[key].playerIsCommitted9)
			setIsCommitted10(loadedTeams[key].playerIsCommitted10)
			setIsCommitted11(loadedTeams[key].playerIsCommitted11)
			setIsCommitted12(loadedTeams[key].playerIsCommitted12)
			setIsCommitted13(loadedTeams[key].playerIsCommitted13)
			setIsCommitted14(loadedTeams[key].playerIsCommitted14)
			setIsCommitted15(loadedTeams[key].playerIsCommitted15)
			setIsCommitted16(loadedTeams[key].playerIsCommitted16)
			setIsCommitted17(loadedTeams[key].playerIsCommitted17)
			setIsCommitted18(loadedTeams[key].playerIsCommitted18)
			setIsCommitted19(loadedTeams[key].playerIsCommitted19)
			setIsCommitted20(loadedTeams[key].playerIsCommitted20)
			setIsCommitted21(loadedTeams[key].playerIsCommitted21)
			setIsCommitted22(loadedTeams[key].playerIsCommitted22)
			setIsCommitted23(loadedTeams[key].playerIsCommitted23)
			setIsCommitted24(loadedTeams[key].playerIsCommitted24)
			setIsCommitted25(loadedTeams[key].playerIsCommitted25)
			setIsCommitted26(loadedTeams[key].playerIsCommitted26)
			setIsCommitted27(loadedTeams[key].playerIsCommitted27)
			setIsCommitted28(loadedTeams[key].playerIsCommitted28)
			setIsCommitted29(loadedTeams[key].playerIsCommitted29)
			setIsCommitted30(loadedTeams[key].playerIsCommitted30)
		}
		//
		setRosterModal(true)
	}
	//
	const cancelRosterHandler = () => {
		setRosterModal(false)
	}
	//

	useEffect(() => {
		// offseason / no teams at all
		if (!loadedTeams) {
			console.log('there are no loaded teams')
			setRem('20rem')
			return
		}

		if (filteredLoadedTeams && filteredLoadedTeams.length > 0) {
			console.log('you are here 1')
			if (filteredLoadedTeams.length < 5) {
				console.log('you are here 2')
				setRem('18rem')
			} else {
				console.log('you are here 3')
				setRem('5rem')
			}
		} else if (filteredLoadedTeams && filteredLoadedTeams.length === 0) {
			setRem('20rem')
		}
	}, [filteredLoadedTeams, loadedTeams])
	//
	//
	//
	//    created by chatGPT
	//
	//
	const downloadRosterExcel = () => {
		if (!selectedTeamObj) return

		const rows = []

		for (let i = 1; i <= 30; i++) {
			const name = selectedTeamObj[`name${i}`]
			const isActive = !!selectedTeamObj[`playerIsActive${i}`]

			// Skip empty slots and INACTIVE players
			if (!name || !isActive) continue

			rows.push({
				Name: name,
				Jersey: selectedTeamObj[`number${i}`] ?? '',
				'Tee Shirt': selectedTeamObj[`teeShirt${i}`] ?? '',
				Hoodie: selectedTeamObj[`hoodie${i}`] ?? '',
			})
		}

		const worksheet = XLSX.utils.json_to_sheet(rows)

		// ✅ ADD THESE TWO LINES AT THE TOP
		XLSX.utils.sheet_add_aoa(
			worksheet,
			[
				['Ship To Name', selectedTeamObj.shipToName ?? ''],
				['Shipping Address', selectedTeamObj.shippingAddress ?? ''],
				[], // spacer row
			],
			{ origin: 'A1' },
		)

		const workbook = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Roster')

		worksheet['!cols'] = [
			{ wch: 26 }, // Name
			{ wch: 40 }, // Make this wider so address fits nicely
			{ wch: 12 }, // Tee Shirt
			{ wch: 12 }, // Hoodie
		]

		const safeOrg = (selectedTeamObj.organization || 'Org')
			.replace(/[^\w\- ]+/g, '')
			.trim()
		const safeTeam = (selectedTeamObj.team || 'Team')
			.replace(/[^\w\- ]+/g, '')
			.trim()

		const fileName = `${safeOrg} - ${safeTeam} Roster.xlsx`

		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		})
		const blob = new Blob([excelBuffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})
		saveAs(blob, fileName)
	}
	/* const downloadRosterExcel = () => {
		if (!selectedTeamObj) return

		const rows = []

		for (let i = 1; i <= 30; i++) {
			const name = selectedTeamObj[`name${i}`]
			const isActive = !!selectedTeamObj[`playerIsActive${i}`]

			// Skip empty slots and INACTIVE players
			if (!name || !isActive) continue

			rows.push({
				Name: name,
				Jersey: selectedTeamObj[`number${i}`] ?? '',
				'Tee Shirt': selectedTeamObj[`teeShirt${i}`] ?? '',
				Hoodie: selectedTeamObj[`hoodie${i}`] ?? '',
			})
		}

		const worksheet = XLSX.utils.json_to_sheet(rows)
		const workbook = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Roster')

		worksheet['!cols'] = [
			{ wch: 26 }, // Name
			{ wch: 8 }, // Jersey
			{ wch: 12 }, // Tee Shirt
			{ wch: 12 }, // Hoodie
		]

		const safeOrg = (selectedTeamObj.organization || 'Org')
			.replace(/[^\w\- ]+/g, '')
			.trim()
		const safeTeam = (selectedTeamObj.team || 'Team')
			.replace(/[^\w\- ]+/g, '')
			.trim()

		const fileName = `${safeOrg} - ${safeTeam} Roster.xlsx`

		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		})
		const blob = new Blob([excelBuffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})
		saveAs(blob, fileName)
	} */

	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<ModalEmail
					show={emailModal}
					onCancel={cancelEmailHandler}
					header='Send an Email'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<div
								className='container'
								style={{ marginTop: '0.5rem', width: '80%' }}
							>
								<form
									method='post'
									enctype='text/plain'
									id='emailForm'
									style={{ height: '80%' }}
								>
									<label>Subject: </label>
									<input
										type='text'
										name='subject'
										className='form-control emailInput'
										defaultValue={'New Message from PABHA'}
										required
									></input>

									<br></br>
									<br></br>

									<label>From: </label>
									<input
										type='text'
										name='from'
										className='form-control emailInput'
										defaultValue='PA Ball Hockey Association'
									></input>

									<br></br>
									<br></br>

									<label>To: </label>
									<input
										type='text'
										name='to'
										className='form-control emailInput'
										defaultValue={uniqueEmailAddresses && uniqueEmailAddresses}
									></input>

									<br></br>
									<br></br>

									<label>Message</label>
									<textarea
										name='message'
										rows='6'
										className='form-control emailInput'
									/>
									<button
										class='buttonButton2'
										type='submit'
										onClick={sendEmail}
									>
										Send
									</button>
									<button
										className='buttonButton2'
										style={{ marginLeft: '2rem' }}
										onClick={cancelEmailHandler}
									>
										CANCEL
									</button>
								</form>
							</div>
							<br></br>
						</React.Fragment>
					}
				></ModalEmail>
				<ModalEmail
					show={rosterModal}
					onCancel={cancelRosterHandler}
					header={org + ' ' + teamName}
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<div
								className='container rosterModalTable'
								style={{
									marginTop: '0.5rem',
									marginBottom: '2rem',
								}}
							>
								<h3>Total Active Players: {totalActivePlayers}</h3>
								<p
									className='goalieOrTaxi'
									style={{ textAlign: 'center', fontSize: 'small' }}
								>
									(G) = Goalie
								</p>
								<p
									className='goalieOrTaxi'
									style={{ textAlign: 'center', fontSize: 'small' }}
								>
									(T) = Taxi Squad
								</p>
								<table className='rosterModalTable'>
									<thead className='tableHeader2'>
										<tr>
											<th>Name</th>
											<th>#</th>
											<th></th>
											<th style={{ textAlign: 'center' }}>Birth Year</th>
											<th></th>
											<th></th>
											<th>Committed?</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name1} {isGoalie1 && '(G)'} {isTaxi1 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number1}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY1}</td>
											{name1 && isActive1 && <td></td>}
											{name1 && !isActive1 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name1 && !isCommitted1 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name1 && isCommitted1 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name2} {isGoalie2 && '(G)'} {isTaxi2 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number2}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY2}</td>

											{name2 && isActive2 && <td></td>}

											{name2 && !isActive2 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name2 && !isCommitted2 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name2 && isCommitted2 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name3} {isGoalie3 && '(G)'} {isTaxi3 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number3}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY3}</td>

											{name3 && isActive3 && <td></td>}

											{name3 && !isActive3 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name3 && !isCommitted3 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name3 && isCommitted3 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name4} {isGoalie4 && '(G)'} {isTaxi4 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number4}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY4}</td>

											{name4 && isActive4 && <td></td>}

											{name4 && !isActive4 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name4 && !isCommitted4 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name4 && isCommitted4 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name5} {isGoalie5 && '(G)'} {isTaxi5 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number5}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY5}</td>

											{name5 && isActive5 && <td></td>}

											{name5 && !isActive5 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name5 && !isCommitted5 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name5 && isCommitted5 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name6} {isGoalie6 && '(G)'} {isTaxi6 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number6}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY6}</td>

											{name6 && isActive6 && <td></td>}

											{name6 && !isActive6 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name6 && !isCommitted6 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name6 && isCommitted6 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name7}
												{isGoalie7 && '(G)'} {isTaxi7 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number7}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY7}</td>

											{name7 && isActive7 && <td></td>}

											{name7 && !isActive7 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name7 && !isCommitted7 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name7 && isCommitted7 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name8} {isGoalie8 && '(G)'} {isTaxi8 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number8}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY8}</td>

											{name8 && isActive8 && <td></td>}

											{name8 && !isActive8 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name8 && !isCommitted8 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name8 && isCommitted8 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name9} {isGoalie9 && '(G)'} {isTaxi9 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number9}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY9}</td>

											{name9 && isActive9 && <td></td>}

											{name9 && !isActive9 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name9 && !isCommitted9 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name9 && isCommitted9 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name10} {isGoalie10 && '(G)'} {isTaxi10 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number10}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY10}</td>

											{name10 && isActive10 && <td></td>}

											{name10 && !isActive10 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name10 && !isCommitted10 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name10 && isCommitted10 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name11} {isGoalie11 && '(G)'} {isTaxi11 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number11}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY11}</td>

											{name11 && isActive11 && <td></td>}

											{name11 && !isActive11 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name11 && !isCommitted11 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name11 && isCommitted11 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name12} {isGoalie12 && '(G)'} {isTaxi12 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number12}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY12}</td>

											{name12 && isActive12 && <td></td>}

											{name12 && !isActive12 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name12 && !isCommitted12 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name12 && isCommitted12 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name13} {isGoalie13 && '(G)'} {isTaxi13 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number13}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY13}</td>

											{name13 && isActive13 && <td></td>}

											{name13 && !isActive13 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name13 && !isCommitted13 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name13 && isCommitted13 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name14} {isGoalie14 && '(G)'} {isTaxi14 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number14}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY14}</td>

											{name14 && isActive14 && <td></td>}

											{name14 && !isActive14 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name14 && !isCommitted14 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name14 && isCommitted14 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name15} {isGoalie15 && '(G)'} {isTaxi15 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number15}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY15}</td>

											{name15 && isActive15 && <td></td>}

											{name15 && !isActive15 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name15 && !isCommitted15 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name15 && isCommitted15 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name16} {isGoalie16 && '(G)'} {isTaxi16 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number16}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY16}</td>

											{name16 && isActive16 && <td></td>}

											{name16 && !isActive16 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name16 && !isCommitted16 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name16 && isCommitted16 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name17} {isGoalie17 && '(G)'} {isTaxi17 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number17}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY17}</td>

											{name17 && isActive17 && <td></td>}

											{name17 && !isActive17 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name17 && !isCommitted17 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name17 && isCommitted17 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name18} {isGoalie18 && '(G)'} {isTaxi18 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number18}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY18}</td>

											{name18 && isActive18 && <td></td>}

											{name18 && !isActive18 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name18 && !isCommitted18 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name18 && isCommitted18 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name19} {isGoalie19 && '(G)'} {isTaxi19 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number19}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY19}</td>

											{name19 && isActive19 && <td></td>}

											{name19 && !isActive19 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name19 && !isCommitted19 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name19 && isCommitted19 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name20} {isGoalie20 && '(G)'} {isTaxi20 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number20}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY20}</td>

											{name20 && isActive20 && <td></td>}

											{name20 && !isActive20 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name20 && !isCommitted20 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name20 && isCommitted20 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name21} {isGoalie21 && '(G)'} {isTaxi21 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number21}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY21}</td>

											{name21 && isActive21 && <td></td>}

											{name21 && !isActive21 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name21 && !isCommitted21 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name21 && isCommitted21 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name22} {isGoalie22 && '(G)'} {isTaxi22 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number22}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY22}</td>

											{name22 && isActive22 && <td></td>}

											{name22 && !isActive22 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name22 && !isCommitted22 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name22 && isCommitted22 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name23} {isGoalie23 && '(G)'} {isTaxi23 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number23}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY23}</td>

											{name23 && isActive23 && <td></td>}

											{name23 && !isActive23 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name23 && !isCommitted23 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name23 && isCommitted23 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name24} {isGoalie24 && '(G)'} {isTaxi24 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number24}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY24}</td>

											{name24 && isActive24 && <td></td>}

											{name24 && !isActive24 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name24 && !isCommitted24 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name24 && isCommitted24 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name25} {isGoalie25 && '(G)'} {isTaxi25 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number25}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY25}</td>

											{name25 && isActive25 && <td></td>}

											{name25 && !isActive25 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name25 && !isCommitted25 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name25 && isCommitted25 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name26} {isGoalie26 && '(G)'} {isTaxi26 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number26}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY26}</td>

											{name26 && isActive26 && <td></td>}

											{name26 && !isActive26 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name26 && !isCommitted26 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name26 && isCommitted26 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name27} {isGoalie27 && '(G)'} {isTaxi27 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number27}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY27}</td>

											{name27 && isActive27 && <td></td>}

											{name27 && !isActive27 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name27 && !isCommitted27 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name27 && isCommitted27 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name28} {isGoalie28 && '(G)'} {isTaxi28 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number28}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY28}</td>

											{name28 && isActive28 && <td></td>}

											{name28 && !isActive28 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name28 && !isCommitted28 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name28 && isCommitted28 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name29} {isGoalie29 && '(G)'} {isTaxi29 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number29}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY29}</td>

											{name29 && isActive29 && <td></td>}

											{name29 && !isActive29 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name29 && !isCommitted29 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name29 && isCommitted29 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
										<tr>
											<td style={{ textAlign: 'left' }}>
												{name30} {isGoalie30 && '(G)'} {isTaxi30 && '(T)'}
											</td>
											<td style={{ textAlign: 'left' }}>{number30}</td>
											<td></td>
											<td style={{ textAlign: 'center' }}>{BY30}</td>

											{name30 && isActive30 && <td></td>}

											{name30 && !isActive30 && (
												<td style={{ textAlign: 'left' }}>INACTIVE</td>
											)}
											<td></td>
											{name30 && !isCommitted30 && (
												<td style={{ textAlign: 'center' }}>No</td>
											)}
											{name30 && isCommitted30 && (
												<td style={{ textAlign: 'center' }}>Yes</td>
											)}
										</tr>
									</tbody>
								</table>
								{auth.coachIsLoggedIn && (
									<div style={{ textAlign: 'center', marginBottom: '1.25rem' }}>
										<Button type='button' onClick={downloadRosterExcel}>
											DOWNLOAD (Excel)
										</Button>
									</div>
								)}
								<div
									style={{
										textAlign: 'center',
										fontWeight: 'bolder',
									}}
								>
									Date of last edit: {dateOfLastEdit}
								</div>
							</div>
							<br></br>
						</React.Fragment>
					}
				></ModalEmail>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && loadedTeams && rem && (
					<div className='RegLeaguesNonAdmin'>
						<HomeHomeNavigation />
						<h1>Tournament Rosters</h1>
						<div
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								marginBottom: isMobileFilters ? '1rem' : '2rem',
							}}
						>
							{!isLoading && loadedTeams && loadedOrgs && (
								<div
									style={{
										width: '100%',
										maxWidth: isMobileFilters ? '320px' : '760px',
										display: 'flex',
										flexDirection: isMobileFilters ? 'column' : 'row',
										alignItems: 'center',
										justifyContent: 'center',
										gap: isMobileFilters ? '0.35rem' : '1.25rem',
										margin: '0 auto',
										padding: isMobileFilters ? '0 0.75rem' : '0',
										boxSizing: 'border-box',
									}}
								>
									{/* ORGANIZATION FILTER */}
									<div
										style={{
											width: isMobileFilters ? '100%' : '300px',
											textAlign: 'center',
										}}
									>
										{/* <div
											style={{
												fontWeight: '700',
												fontSize: isMobileFilters ? '0.95rem' : '1.05rem',
												marginBottom: isMobileFilters ? '0.3rem' : '0.45rem',
												lineHeight: 1.2,
											}}
										>
											Filter by Organization
										</div> */}

										<select
											className='selectLeagueDropdown'
											value={selectedFilterOrg}
											onChange={handleFilterByOrg}
											style={{
												width: '100%',
												height: isMobileFilters ? '38px' : '42px',
												padding: '0 10px',
												fontSize: isMobileFilters ? '0.95rem' : '1rem',
												borderRadius: '4px',
												border: '1px solid #9aa0a6',
												backgroundColor: 'white',
												boxSizing: 'border-box',
												textAlign: 'center',
												textAlignLast: 'center',
											}}
										>
											<option value=''>
												{selectedFilterTeam
													? 'FILTER BY ORGANIZATION'
													: 'ALL ORGANIZATIONS'}
											</option>

											{orgArray.map((org, i) => (
												<option value={org} key={i}>
													{org.toUpperCase()}
												</option>
											))}
										</select>
									</div>

									{/* OR DIVIDER */}
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											width: isMobileFilters ? '100%' : '42px',
											minWidth: isMobileFilters ? '100%' : '42px',
											color: '#666',
											fontWeight: '700',
											fontSize: isMobileFilters ? '0.95rem' : '1rem',
											marginTop: isMobileFilters ? '0' : '0',
										}}
									>
										{isMobileFilters ? (
											<>
												<div
													style={{
														height: '1px',
														backgroundColor: '#b7b7b7',
														flex: 1,
													}}
												></div>

												<div style={{ margin: '0 12px' }}>or</div>

												<div
													style={{
														height: '1px',
														backgroundColor: '#b7b7b7',
														flex: 1,
													}}
												></div>
											</>
										) : (
											<div style={{ lineHeight: 1 }}>OR</div>
										)}
									</div>

									{/* TEAM FILTER */}
									<div
										style={{
											width: isMobileFilters ? '100%' : '300px',
											textAlign: 'center',
										}}
									>
										{/* <div
											style={{
												fontWeight: '700',
												fontSize: isMobileFilters ? '0.95rem' : '1.05rem',
												marginBottom: isMobileFilters ? '0.3rem' : '0.45rem',
												lineHeight: 1.2,
											}}
										>
											Filter by Team
										</div> */}

										<select
											className='selectLeagueDropdown'
											value={selectedFilterTeam}
											onChange={handleFilterByTeam}
											style={{
												width: '100%',
												height: isMobileFilters ? '38px' : '42px',
												padding: '0 10px',
												fontSize: isMobileFilters ? '0.95rem' : '1rem',
												borderRadius: '4px',
												border: '1px solid #9aa0a6',
												backgroundColor: 'white',
												boxSizing: 'border-box',
												textAlign: 'center',
												textAlignLast: 'center',
											}}
										>
											<option value=''>
												{selectedFilterOrg
													? 'FILTER BY DIVISION'
													: 'ALL DIVISIONS'}
											</option>

											{teamArray.map((team, i) => (
												<option value={team} key={i}>
													{team.toUpperCase()}
												</option>
											))}
										</select>
									</div>
								</div>
							)}
						</div>
						<div className='rosterDesktopTable'>
							<table id='regLeaguesNonAdmin'>
								<thead>
									<tr>
										{/* <th>Year</th> */}
										<th>Org</th>
										<th>Team</th>
										<th>Coaches</th>
										{/* <th>Assistant Coaches</th> */}
										<th></th>
									</tr>
								</thead>
								<tbody>
									{filteredLoadedTeams &&
										filteredLoadedTeams.map((team, key) => {
											return (
												<tr key={key}>
													{/* <td>{team.year}</td> */}
													<td>{team.organization}</td>
													<td>
														{team.manualOrg && <div>{team.manualOrg}</div>}
														{team.team}
													</td>
													<td>
														{team.headCoach} (HC), {team.assistantCoaches}
													</td>
													{/* <td>{team.assistantCoaches}</td> */}
													<td>
														<Button
															type='button'
															onClick={(e) => showRosterModal(e, key)}
															exact
															style={{
																color: 'white',
																textDecoration: 'none',
																backgroundColor: '#e0e0e0',
															}}
														>
															Roster
														</Button>
													</td>
												</tr>
											)
										})}
									{!filteredLoadedTeams &&
										loadedTeams.map((team, key) => {
											return (
												<tr key={key}>
													{/* <td>{team.year}</td> */}
													<td>{team.organization}</td>
													<td>
														{team.manualOrg && <div>{team.manualOrg}</div>}
														{team.team}
													</td>
													<td>
														{team.headCoach} (HC), {team.assistantCoaches}
													</td>
													{/* <td>{team.assistantCoaches}</td> */}
													<td>
														<Button
															type='button'
															onClick={(e) => showRosterModal(e, key)}
															exact
														>
															Roster
														</Button>
													</td>
												</tr>
											)
										})}
								</tbody>
							</table>
						</div>
						<div className='rosterMobileTable'>
							{(filteredLoadedTeams || loadedTeams).map((team, key) => (
								<div
									key={key}
									style={{
										backgroundColor: key % 2 === 0 ? 'white' : '#f1f1f1',
										marginBottom: '8px',
										padding: '0.9rem 0.75rem',
										borderRadius: '9px',
										boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
									}}
								>
									{/* TOP ROW */}
									<div
										style={{
											display: 'grid',
											gridTemplateColumns: '1fr 1fr auto',
											alignItems: 'center',
											columnGap: '0.6rem',
										}}
									>
										{/* ORGANIZATION */}
										<div
											style={{
												fontSize: '0.8rem',
												overflowWrap: 'anywhere',
											}}
										>
											{team.organization}
										</div>

										{/* TEAM */}
										<div
											style={{
												fontSize: '0.9rem',
												fontWeight: 'bold',
												overflowWrap: 'anywhere',
											}}
										>
											{team.manualOrg && (
												<div
													style={{
														fontSize: '0.72rem',
														fontWeight: 'normal',
														marginBottom: '2px',
													}}
												>
													{team.manualOrg}
												</div>
											)}

											{team.team}
										</div>

										{/* ROSTER BUTTON */}
										<button
											type='button'
											onClick={(e) => showRosterModal(e, key)}
											style={{
												border: 'none',
												backgroundColor: '#ff0018',
												color: 'white',
												fontWeight: 'bold',
												fontSize: '0.74rem',
												padding: '0.5rem 0.65rem',
												borderRadius: '5px',
												cursor: 'pointer',
												whiteSpace: 'nowrap',
											}}
										>
											Roster
										</button>
									</div>

									{/* DIVIDER */}
									<div
										style={{
											height: '1px',
											backgroundColor: '#d8d8d8',
											margin: '0.7rem 0',
										}}
									></div>

									{/* COACHES ROW */}
									<div
										style={{
											display: 'grid',
											gridTemplateColumns: '72px 1fr',
											columnGap: '0.6rem',
											alignItems: 'start',
										}}
									>
										<div
											style={{
												fontSize: '0.82rem',
												color: '#666',
											}}
										>
											Coaches:
										</div>

										<div
											style={{
												fontSize: '0.9rem',
												lineHeight: '1.4',
												overflowWrap: 'anywhere',
											}}
										>
											{team.headCoach} (HC)
											{team.assistantCoaches && `, ${team.assistantCoaches}`}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				)}
				<div style={{ marginTop: rem }}>
					<Footer />
				</div>
			</React.Fragment>
		</div>
	)
}

export default NonAdminRegisteredTeams
